














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ImagePreview from './ImagePreview.vue'

@Component({
  components: {
    'image-preview': ImagePreview,
  },
})
export default class ImagePreviewEditable extends Vue {

  @Prop({ required: true })
  index: number

  @Prop({ required: true })
  onClick: (index: number) => void

  @Prop({ required: true })
  preview: File
}
